import { useTranslations } from 'next-intl';

import { Dialog, DialogHeadingWithCloseIcon } from '@/blocks/components/Modal/Dialog';
import typography from '@/styles/typography.module.scss';

import { TradingHolidaysTable } from './TradingHolidaysTable';
import styles from './styles.module.scss';

export function TradingHolidaysModal({ isOpen, onClose }: { isOpen: boolean; onClose(): void }) {
  const tr = useTranslations('pages.cfd.all.sections.markets.modal');

  return (
    <Dialog open={isOpen} onClose={onClose} className={styles.holidaysDialog}>
      <DialogHeadingWithCloseIcon onClose={onClose} className={styles.modalHeading}>
        {tr.rich('title')}
      </DialogHeadingWithCloseIcon>
      <div className={styles.modalDescription}>
        <p className={typography.bodyM}>{tr.rich('subtitle')}</p>
        <p className={typography.bodyM}>{tr.rich('subheading')}</p>
      </div>
      <TradingHolidaysTable />
    </Dialog>
  );
}
